import React from "react"
import { Col, Container, Row } from 'reactstrap';
import { T } from "../../traks";

const IntroStep = ({ whistle, setWhistle, nextStep, company }) => {
	const { logo, name } = company
	const buttonDisabled = !whistle.agreeToTerms;
	const fallbackLogo = "https://static.sibilus.eu/gfx/pentus-logo-0.svg";
	const shownLogo = (logo === "" || logo === undefined) ? fallbackLogo : logo;

	return (
		<Container fluid>
			<Row>
				<Col xs={12} lg={6} className="d-none d-lg-flex">
					<div className="d-flex flex-column justify-content-end w-100">
						<img alt='create case' style={{ objectFit: "cover", width: "100%" }} src='https://static.sibilus.eu/gfx/create_case_gfx-0.svg' />
					</div>
				</Col>
				<Col xs={12} lg={6} className="bg-white vh-100 px-2 px-lg-5">
					<div className="d-flex flex-column px-1 px-lg-5">
						<div className="text-center my-5">
							<img className="create_whistle_logo" src={shownLogo} alt="company logo" />
						</div>
						<div className="font_28px primary fw_700 pb-5">
							<T>Report an issue</T>
						</div>
						<div className="create_whistle_page font_13px pb-3">
							<div>
								<T>
									Here you can submit information about objectionable circumstances if you are an employee of or business
									partner for
								</T>
								{" " + name}.
							</div>
							<div>
								<T>
									Before you submit information, it is important that you have familiarized yourself with what can be reported
									on, as described on our website and that you read the Ministry of Justice's guidance in the area. Here you
									can e.g. find information about what is covered by the whistleblower scheme, how your information is handled
									and what rights you have as a whistleblower. You can find the guidance on the website of the Ministry of
									Justice.
								</T>
							</div>
							<div>
								<T>
									We do not log information that can be used to track you when you click Submit a report. If you wish to be
									anonymous and to protect your anonymity, you must e.g. be aware that you must refrain from giving your name
									or other personally identifiable information, that files such as documents and images may contain metadata
									that could mean that your anonymity is compromised, that you do not access the portal via the link on one of
									the authorities' websites, but instead enter the web address https://bm-dep.sit-wb.dk in a blank browser and
									that you must refrain from using a computer that is on an authority's network.
									When you have submitted the report, you will receive a receipt, and you will be contacted via the system as
									soon as possible. If your inquiry is more urgent than that, you should use other channels, e.g. the police,
									if criminal matters are involved.
								</T>
							</div>
						</div>
						<div className="sibilus_checkbox d-flex">
							<input
								id="i_agree_checkbox"
								type="checkbox"
								checked={whistle.agreeToTerms}
								onChange={() => setWhistle({ ...whistle, agreeToTerms: !whistle.agreeToTerms })}
							/>
							<label htmlFor="i_agree_checkbox"></label>
							<label className="checkbox_text ps-2" htmlFor="i_agree_checkbox">
								<T>I hereby approve that this case may be handed over to the relevant authority</T>
							</label>
						</div>
						<div className="text-center py-5">
							<button className={`btn btn_green ${buttonDisabled}`} disabled={buttonDisabled} onClick={() => nextStep(false)} >
								<span className="px-3"><T>Continue</T> </span>
							</button>
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
}

export { IntroStep }
